import some from 'lodash/some';

export function buildWebhookURL(webhook) {
  const { id, authenticationType, ownerApiKey, baseUrl, isRunningInCloud } =
    webhook;

  if (!id) {
    return '';
  }

  const protocol = isRunningInCloud === false ? 'http' : 'https';
  const base = baseUrl ? `${protocol}://${baseUrl}` : window.location.origin;

  const url = `${base}/api/integration/1/functions/${id}/triggers`;

  if (['URL', 'URL_AUTH'].includes(authenticationType)) {
    return `${url}?apiKey=${ownerApiKey}`;
  }

  return url;
}

export const isFlowIntegration = ({ createdBy, type }) =>
  [
    'OUTBOUND_WEBHOOK',
    'INBOUND_EMAIL',
    'CUSTOM_HTTP',
    'FORM_TRIGGER',
    'AUTOMATION_TRIGGER',
    'EBFD_INCIDENT_RESPONSE_TRIGGER',
  ].includes(type) ||
  (type === 'INBOUND_WEBHOOK' && createdBy === 'FLOW');

/**
 * Pre-save data preparation methods:
 */
export const MODIFIABLE_INTEGRATION_FIELDS = [
  'agents',
  'authenticationType',
  'deployed',
  'environment',
  'name',
  'runAs',
  'script',
  'scriptStep',
  'triggerFilter',
  'triggerId',
  'incidentTemplateId',
  'runAsTriggerUser',
  'preventDuplicateEbIncidentResponses',
];
const hasChanges = (changeSet, baseObj, fieldsProp) => {
  if (!changeSet) {
    return false;
  }
  // setting `isDirty` true on the changes is a nuclear option to force saving. Ideally avoid this.
  if (!baseObj || changeSet.isDirty) {
    return true;
  }

  const fields = fieldsProp || Object.keys(changeSet);
  return some(
    fields,
    key => changeSet[key] !== undefined && changeSet[key] !== baseObj[key],
  );
};

export const integrationHasChanges = (
  newData,
  oldIntegration,
  fieldsToCheck = MODIFIABLE_INTEGRATION_FIELDS,
) => hasChanges(newData, oldIntegration, fieldsToCheck);

/**
 * Extract Integration name without id
 * @param {string} name Integration name. Example: "form2 - Email Initiation - 776072bf-5b50-406e-b3b3-9a95c51101fa"
 * @param {string} id Integration id. Example: "776072bf-5b50-406e-b3b3-9a95c51101fa"
 * @returns {string} Integration name without id or original name. Example: "form2 - Email Initiation"
 */
export const extractIntegrationNameWithoutId = (id, name) => {
  return name.replace(` - ${id}`, '');
};
